import { colorTokens } from "../../tokens";

function GithubIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0,0,256,256"
      width="100px"
      height="100px"
      aria-hidden="true"
      focusable="false"
    >
      <g>
        <g transform="scale(2.56,2.56)">
          <path
            className="blueParticle"
            d="M13,27c-1.10457,0 -2,0.89543 -2,2c0,1.10457 0.89543,2 2,2c1.10457,0 2,-0.89543 2,-2c0,-1.10457 -0.89543,-2 -2,-2z"
            fill={colorTokens.mint}
          />
          <path
            className="yellowParticle"
            d="M77,12c-0.55228,0 -1,0.44772 -1,1c0,0.55228 0.44772,1 1,1c0.55228,0 1,-0.44772 1,-1c0,-0.55228 -0.44772,-1 -1,-1z"
            fill={colorTokens.accent}
          />
          <path
            d="M50,13c-20.43454,0 -37,16.56546 -37,37c0,20.43454 16.56546,37 37,37c20.43454,0 37,-16.56546 37,-37c0,-20.43454 -16.56546,-37 -37,-37z"
            fill={colorTokens.mint}
          />
          <path
            className="yellowParticle"
            d="M83,11c-2.20914,0 -4,1.79086 -4,4c0,2.20914 1.79086,4 4,4c2.20914,0 4,-1.79086 4,-4c0,-2.20914 -1.79086,-4 -4,-4z"
            fill={colorTokens.accent}
          />
          <path
            className="blueParticle"
            d="M87,22c-1.10457,0 -2,0.89543 -2,2c0,1.10457 0.89543,2 2,2c1.10457,0 2,-0.89543 2,-2c0,-1.10457 -0.89543,-2 -2,-2z"
            fill={colorTokens.mint}
          />
          <path
            className="yellowParticle"
            d="M81,74c-1.10457,0 -2,0.89543 -2,2c0,1.10457 0.89543,2 2,2c1.10457,0 2,-0.89543 2,-2c0,-1.10457 -0.89543,-2 -2,-2zM15,59c-2.20914,0 -4,1.79086 -4,4c0,2.20914 1.79086,4 4,4c2.20914,0 4,-1.79086 4,-4c0,-2.20914 -1.79086,-4 -4,-4z"
            fill={colorTokens.accent}
          />
          <path
            className="blueParticle"
            d="M25,85c-1.10457,0 -2,0.89543 -2,2c0,1.10457 0.89543,2 2,2c1.10457,0 2,-0.89543 2,-2c0,-1.10457 -0.89543,-2 -2,-2z"
            fill={colorTokens.mint}
          />
          <g>
            <path
              d="M50,25.625c-13.39291,0 -24.25,10.85709 -24.25,24.25c0,13.39291 10.85709,24.25 24.25,24.25c13.39291,0 24.25,-10.85709 24.25,-24.25c0,-13.39291 -10.85709,-24.25 -24.25,-24.25z"
              fill={colorTokens.svgLavender}
            />
            <path
              d="M50,74.825c-13.757,0 -24.95,-11.192 -24.95,-24.95c0,-13.758 11.193,-24.95 24.95,-24.95c13.757,0 24.95,11.192 24.95,24.95c0,13.758 -11.193,24.95 -24.95,24.95zM50,26.325c-12.985,0 -23.55,10.564 -23.55,23.55c0,12.986 10.565,23.55 23.55,23.55c12.985,0 23.55,-10.564 23.55,-23.55c0,-12.986 -10.565,-23.55 -23.55,-23.55z"
              fill={colorTokens.svgBrown}
            />
          </g>
          <g fill={colorTokens.backgroundDark} className="darkCirle">
            <path d="M50,29.167c-11.32184,0 -20.5,9.17816 -20.5,20.5c0,11.32184 9.17816,20.5 20.5,20.5c11.32184,0 20.5,-9.17816 20.5,-20.5c0,-11.32184 -9.17816,-20.5 -20.5,-20.5z" />
          </g>
          <g fill={colorTokens.svgBrown} className="outlinePart">
            <path d="M69.424,44.625c-0.214,0 -0.412,-0.139 -0.478,-0.354c-0.088,-0.287 -0.183,-0.571 -0.284,-0.853c-0.392,-1.094 -0.886,-2.159 -1.47,-3.169c-0.139,-0.238 -0.057,-0.545 0.182,-0.683c0.239,-0.141 0.545,-0.057 0.683,0.183c0.614,1.061 1.134,2.182 1.546,3.331c0.106,0.297 0.206,0.595 0.298,0.897c0.081,0.264 -0.067,0.544 -0.332,0.625c-0.048,0.016 -0.097,0.023 -0.145,0.023z" />
          </g>
          <g fill={colorTokens.svgBrown} className="outlinePart">
            <path d="M50,70.75c-11.511,0 -20.875,-9.337 -20.875,-20.813c0,-11.476 9.364,-20.812 20.875,-20.812c5.975,0 11.674,2.56 15.636,7.023c0.299,0.337 0.588,0.685 0.865,1.041c0.169,0.218 0.13,0.531 -0.087,0.701c-0.218,0.171 -0.532,0.131 -0.702,-0.088c-0.264,-0.339 -0.54,-0.669 -0.824,-0.99c-3.772,-4.25 -9.199,-6.688 -14.888,-6.688c-10.959,0 -19.875,8.888 -19.875,19.813c0,10.925 8.916,19.813 19.875,19.813c10.959,0 19.875,-8.888 19.875,-19.813c0,-0.995 -0.075,-1.996 -0.222,-2.973c-0.041,-0.272 0.147,-0.527 0.42,-0.568c0.278,-0.045 0.528,0.147 0.569,0.42c0.154,1.025 0.233,2.076 0.233,3.121c0,11.476 -9.364,20.813 -20.875,20.813z" />
          </g>
          <g>
            <path
              className="contentPart"
              d="M61.496,42.088c0.365,-1.671 0.206,-3.743 -0.486,-5.818c-3.622,0 -6.339,2.716 -6.339,2.716c0,0 0.016,0.018 0.02,0.023c-0.064,-0.001 -0.126,-0.009 -0.191,-0.009h-9c-0.043,0 -0.085,0.006 -0.128,0.006c0.003,-0.004 0.017,-0.02 0.017,-0.02c0,0 -2.717,-2.716 -6.339,-2.716c-0.684,2.053 -0.85,4.104 -0.5,5.767c-1.577,1.695 -2.55,3.963 -2.55,6.463c0,5.247 4.253,9.5 9.5,9.5h1.073c-1.304,0.709 -2.246,1.979 -2.493,3.498c-1.72,0.232 -3.979,0.18 -5.028,-1.394c-1.811,-2.717 -2.717,-2.717 -3.622,-2.717c-0.905,0 -0.906,0.906 0,1.811c0.906,0.906 0.906,0.906 1.811,2.717c0.772,1.543 2.812,3.298 6.76,2.663v3.523c0,0.447 0.079,0.871 0.191,1.282c2.425,0.577 6.502,1.061 11.665,-0.151c0.086,-0.364 0.143,-0.739 0.143,-1.13v-5.816c0,-1.858 -1.047,-3.456 -2.573,-4.286h1.073c5.247,0 9.5,-4.253 9.5,-9.5c0,-2.475 -0.954,-4.721 -2.504,-6.412z"
              fill={colorTokens.svgCream}
            />
            <path
              className="contentPart"
              d="M49.532,70.486c-2.23,0 -4.075,-0.287 -5.457,-0.616c-0.178,-0.042 -0.319,-0.179 -0.367,-0.355c-0.142,-0.522 -0.208,-0.972 -0.208,-1.413v-2.952c-4.563,0.514 -6.279,-2.154 -6.707,-3.011c-0.87,-1.739 -0.87,-1.739 -1.717,-2.587c-0.701,-0.701 -0.979,-1.458 -0.745,-2.023c0.169,-0.408 0.569,-0.642 1.098,-0.642c1.217,0 2.219,0.211 4.038,2.939c0.839,1.258 2.676,1.379 4.193,1.218c0.23,-0.978 0.724,-1.855 1.423,-2.554c-5.321,-0.218 -9.583,-4.615 -9.583,-9.99c0,-2.442 0.891,-4.78 2.513,-6.613c-0.306,-1.722 -0.108,-3.761 0.564,-5.775c0.068,-0.204 0.259,-0.342 0.474,-0.342c3.357,0 5.931,2.16 6.552,2.73h8.854c0.621,-0.57 3.195,-2.73 6.552,-2.73c0.215,0 0.406,0.138 0.474,0.342c0.679,2.037 0.872,4.096 0.551,5.83c1.591,1.826 2.465,4.146 2.465,6.559c0,5.375 -4.263,9.773 -9.585,9.991c1.001,0.997 1.585,2.354 1.585,3.794v5.816c0,0.392 -0.052,0.8 -0.158,1.246c-0.043,0.185 -0.188,0.328 -0.372,0.371c-2.387,0.561 -4.55,0.767 -6.437,0.767zM44.602,68.965c2.412,0.537 6.153,0.9 10.83,-0.148c0.045,-0.253 0.068,-0.489 0.068,-0.715v-5.816c0,-1.597 -0.886,-3.07 -2.312,-3.846c-0.201,-0.109 -0.302,-0.341 -0.246,-0.563c0.056,-0.222 0.256,-0.377 0.484,-0.377h1.074c4.962,0 9,-4.037 9,-9c0,-2.247 -0.843,-4.404 -2.373,-6.074c-0.11,-0.12 -0.154,-0.286 -0.12,-0.444c0.331,-1.517 0.202,-3.352 -0.36,-5.202c-2.87,0.153 -5.098,2.074 -5.542,2.484c-0.091,0.151 -0.245,0.246 -0.429,0.246c-0.007,0 -0.096,-0.006 -0.103,-0.006l-9.073,-0.004c-0.152,0 -0.332,-0.067 -0.442,-0.181l-0.021,0.021c-0.025,-0.024 -2.438,-2.39 -5.623,-2.561c-0.557,1.831 -0.69,3.649 -0.373,5.154c0.034,0.159 -0.013,0.325 -0.124,0.444c-1.559,1.675 -2.417,3.85 -2.417,6.123c0,4.963 4.038,9 9,9h1.073c0.229,0 0.428,0.155 0.484,0.377c0.057,0.222 -0.044,0.453 -0.246,0.563c-1.205,0.654 -2.021,1.799 -2.238,3.139c-0.036,0.218 -0.208,0.386 -0.427,0.415c-2.664,0.358 -4.568,-0.198 -5.511,-1.611c-1.663,-2.494 -2.412,-2.494 -3.206,-2.494c-0.137,0 -0.18,0.032 -0.181,0.032c-0.025,0.064 0.043,0.435 0.534,0.926c0.963,0.963 0.998,1.033 1.905,2.847c0.369,0.739 1.939,3.016 6.226,2.327c0.146,-0.021 0.293,0.019 0.406,0.114c0.113,0.095 0.179,0.235 0.179,0.383v3.523c0.001,0.286 0.035,0.557 0.108,0.863z"
              fill={colorTokens.svgBrown}
            />
          </g>
          <g>
            <path
              className="contentPart"
              d="M60.437,51.362c-0.9,1.994 -2.876,3.652 -6.354,3.93"
              fill={colorTokens.svgCream}
            />
            <path
              className="contentPart"
              d="M54.083,55.542c-0.129,0 -0.238,-0.1 -0.249,-0.23c-0.011,-0.138 0.091,-0.258 0.229,-0.269c3.805,-0.305 5.442,-2.227 6.146,-3.784c0.058,-0.127 0.205,-0.183 0.331,-0.125c0.125,0.057 0.182,0.204 0.125,0.33c-1.073,2.377 -3.403,3.824 -6.562,4.077c-0.006,0.001 -0.013,0.001 -0.02,0.001z"
              fill={colorTokens.svgBrown}
            />
          </g>
          <g>
            <path
              className="contentPart"
              d="M60.959,47.41c0.111,0.753 0.109,1.552 -0.03,2.342"
              fill={colorTokens.svgCream}
            />
            <path
              className="contentPart"
              d="M60.93,50.002c-0.015,0 -0.029,-0.001 -0.044,-0.004c-0.136,-0.023 -0.227,-0.153 -0.203,-0.289c0.129,-0.734 0.139,-1.517 0.029,-2.263c-0.021,-0.136 0.074,-0.264 0.21,-0.283c0.137,-0.02 0.264,0.073 0.284,0.211c0.12,0.809 0.109,1.624 -0.031,2.421c-0.02,0.122 -0.126,0.207 -0.245,0.207z"
              fill={colorTokens.svgBrown}
            />
          </g>
          <g>
            <path
              className="contentPart"
              d="M59.083,43.875c0.633,0.451 1.146,1.179 1.488,2.055"
              fill={colorTokens.svgCream}
            />
            <path
              className="contentPart"
              d="M60.571,46.181c-0.1,0 -0.194,-0.061 -0.233,-0.159c-0.334,-0.856 -0.818,-1.528 -1.4,-1.942c-0.112,-0.08 -0.139,-0.236 -0.059,-0.349c0.081,-0.113 0.236,-0.138 0.349,-0.06c0.662,0.472 1.207,1.222 1.576,2.169c0.05,0.129 -0.014,0.273 -0.142,0.324c-0.03,0.011 -0.06,0.017 -0.091,0.017z"
              fill={colorTokens.svgBrown}
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default GithubIcon;
